import React, { useEffect } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { connect } from 'react-redux'

import { CustomModal, CustomCheckbox } from '../../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import useModalAssocOpLog, { LOAD_MESSAGE } from './ModalAssocOperadorLogisticoHook'

function ModalAssocOperadorLogistico({ dispatch, show, onModalClose, customer }) {
  const { state, localDispatch } = useModalAssocOpLog()

  useEffect(() => {
    if (show) localDispatch.onInit(customer)
  }, [customer, show])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.INITIAL_CHECK:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.getTpsCustomerAssociation(customer ? customer.id : customer)
        break

      case LOAD_MESSAGE.SWITCH_ASSOC:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.switchCustomerAssociationWithTP(state.association)
        break

      default:
        break
    }
  }, [state.loadingMessage, state.customer])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  return (
    <CustomModal
      header={`Associação: ${customer ? customer.nomeFantasia : ''}`}
      isVisible={show}
      onClose={onModalClose}
      width={600}
    >
      <DataTable value={state.associations} paginator={true} rows={5}>
        <Column
          field="actived"
          header=""
          style={{ textAlign: 'center', width: 100 }}
          body={association => (
            <CustomCheckbox
              checked={association.actived}
              onChange={() => localDispatch.onCheckBoxClicked(association)}
            />
          )}
        />
        <Column field="tp_name" header="Operador Logístico" />
      </DataTable>
    </CustomModal>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(ModalAssocOperadorLogistico)
